// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-media {
  width: 100%;
  position: relative;
}
.upload-media .upload-file-layer {
  display: none;
}
.upload-media .media-drop-empty .drop-zone {
  min-height: 400px;
}
.upload-media .upload-file-layer .drop-zone {
  border-radius: 10px;
}
.upload-media .active-file-layer {
  display: block;
}
.upload-media .action-panel {
  z-index: 2;
  padding: 10px;
  position: absolute;
  top: 0;
  right: 0;
  padding: 10px;
  text-align: right;
  box-sizing: border-box;
  font-size: 25px;
  color: var(--secondary-color);
  pointer-events: none;
  opacity: 0;
  width: 100%;
}
.upload-media .action-panel.shown {
  opacity: 1;
  transition: 0.4s opacity;
  display: flex;
  justify-content: flex-end;
  pointer-events: initial;
}
.upload-media .action-panel.shown .button-circled.media-links {
  margin-right: auto;
}
.upload-media .media-mote-links .svg-icon {
  display: inline-block;
  line-height: 22px;
}
.upload-media .media-mote-links label {
  margin: 0;
}
.upload-media .meta-data-overlay {
  z-index: 2;
  position: absolute;
  top: 0;
  color: white;
  border-radius: var(--border-radius);
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.upload-media .meta-data-overlay .meta-data-action-panel {
  z-index: 3;
  position: absolute;
  display: flex;
  top: var(--motes-padding);
  right: var(--motes-padding);
}
.upload-media .meta-data-overlay .meta-data-action-panel button {
  box-sizing: border-box;
}
.upload-media .meta-data-overlay .meta-data-action-panel button svg-icon > span > svg {
  height: 10px;
}
.upload-media .meta-data-overlay .meta-form-wrapper {
  height: 100%;
  box-sizing: border-box;
  margin: 0px var(--element-spacing);
  padding: var(--element-spacing) 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.upload-media .meta-data-overlay .meta-form-wrapper input-form-field {
  margin: 0px;
}
.upload-media .video-edit-wrapper {
  pointer-events: none;
  z-index: 2;
  position: absolute;
  top: 0;
  color: white;
  border-radius: var(--border-radius);
  padding: var(--motes-padding);
  box-sizing: border-box;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0) 50%, rgb(0, 0, 0) 100%);
  width: 100%;
  height: 100%;
  display: flex;
}
.upload-media .video-edit-wrapper .video-edit-action-panel {
  z-index: 3;
  display: flex;
}
.upload-media .video-edit-wrapper .video-edit-action-panel button {
  box-sizing: border-box;
  pointer-events: auto;
}
.upload-media .video-edit-wrapper .video-edit-action-panel button svg-icon > span > svg {
  height: 10px;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/upload-media/upload-media.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,kBAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,iBAAA;AAAR;AAGI;EACI,mBAAA;AADR;AAII;EACI,cAAA;AAFR;AAKI;EACI,UAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,6BAAA;EACA,oBAAA;EACA,UAAA;EACA,WAAA;AAHR;AAMI;EACI,UAAA;EACA,wBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;AAJR;AAMQ;EACI,kBAAA;AAJZ;AASQ;EACI,qBAAA;EACA,iBAAA;AAPZ;AAUQ;EACI,SAAA;AARZ;AAYI;EACI,UAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AAVR;AAYQ;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,2BAAA;AAVZ;AAYY;EACI,sBAAA;AAVhB;AAYgB;EACI,YAAA;AAVpB;AAeQ;EACI,YAAA;EACA,sBAAA;EACA,kCAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AAbZ;AAeY;EACI,WAAA;AAbhB;AAkBI;EACI,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,mCAAA;EACA,6BAAA;EACA,sBAAA;EACA,gFAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAhBR;AAkBQ;EACI,UAAA;EACA,aAAA;AAhBZ;AAkBY;EACI,sBAAA;EACA,oBAAA;AAhBhB;AAkBgB;EACI,YAAA;AAhBpB","sourcesContent":[".upload-media {\n    width: 100%;\n    position: relative;\n\n    .upload-file-layer {\n        display: none;\n    }\n\n    .media-drop-empty .drop-zone {\n        min-height: 400px;\n    }\n\n    .upload-file-layer .drop-zone {\n        border-radius: 10px;\n    }\n\n    .active-file-layer {\n        display: block;\n    }\n\n    .action-panel {\n        z-index: 2;\n        padding: 10px;\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 10px;\n        text-align: right;\n        box-sizing: border-box;\n        font-size: 25px;\n        color: var(--secondary-color);\n        pointer-events: none;\n        opacity: 0;\n        width: 100%;\n    }\n\n    .action-panel.shown {\n        opacity: 1;\n        transition: 0.4s opacity;\n        display: flex;\n        justify-content: flex-end;\n        pointer-events: initial;\n\n        .button-circled.media-links {\n            margin-right: auto;\n        }\n    }\n\n    .media-mote-links {\n        .svg-icon {\n            display: inline-block;\n            line-height: 22px;\n        }\n\n        label {\n            margin: 0;\n        }\n    }\n\n    .meta-data-overlay {\n        z-index: 2;\n        position: absolute;\n        top: 0;\n        color: white;\n        border-radius: var(--border-radius);\n        background-color: rgba(0, 0, 0, 0.5);\n        width: 100%;\n        height: 100%;\n\n        .meta-data-action-panel {\n            z-index: 3;\n            position: absolute;\n            display: flex;\n            top: var(--motes-padding);\n            right: var(--motes-padding);\n\n            button {\n                box-sizing: border-box;\n\n                svg-icon > span > svg {\n                    height: 10px;\n                }\n            }\n        }\n\n        .meta-form-wrapper {\n            height: 100%;\n            box-sizing: border-box;\n            margin: 0px var(--element-spacing);\n            padding: var(--element-spacing) 0px;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-around;\n\n            input-form-field {\n                margin: 0px;\n            }\n        }\n    }\n\n    .video-edit-wrapper {\n        pointer-events: none;\n        z-index: 2;\n        position: absolute;\n        top: 0;\n        color: white;\n        border-radius: var(--border-radius);\n        padding: var(--motes-padding);\n        box-sizing: border-box;\n        background: linear-gradient(0deg, rgba(255,255,255,0) 50%, rgba(0,0,0,1) 100%);\n        width: 100%;\n        height: 100%;\n        display: flex;\n\n        .video-edit-action-panel {\n            z-index: 3;\n            display: flex;\n\n            button {\n                box-sizing: border-box;\n                pointer-events: auto;\n\n                svg-icon > span > svg {\n                    height: 10px;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
